<template>
  <div>
    <div class="action-plan-title">
      {{ this.title }}
      <chevrons
        class="action-plan-title-chevron"
        :is-large="true"
        :is-open="this.isOpen"
        @on-chevon-click="toggleChevron"
      />
    </div>

    <div v-if="this.isOpen">
      <b-table :items="tableData" :fields="fields">
        <template #cell(reportName)="data">
          <span>{{ data.value }}</span>
        </template>

        <template #cell(contentName)="data">
          <span>{{ data.value }}</span>
        </template>

        <template #cell(description)="data">
          <span>{{ data.value }}</span>
        </template>

        <template #cell(studioVersion)="data">
          <span>{{ data.value }}</span>
        </template>

        <template #cell(successful)="data">
          <div class="studio-status">
            <div class="s-status" v-if="data.value">
              {{ getMessageText(messages.Success) }}
            </div>
            <div class="s-status generic_exclamation" v-else></div>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
  import Chevrons from "@/views/drag-drop-pages/components/Chevrons.vue";
  import { mapState } from "vuex";

  export default {
    name: "ImportCustomContentModalSection",
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      })
    },
    components: {
      Chevrons
    },
    props: {
      title: {
        default: function() {
          return {};
        },
        type: Object
      },
      content: {
        default: function() {
          return {};
        },
        type: Object
      },
      fields: {
        default: function() {
          return [];
        },
        type: Object
      }
    },
    data() {
      return {
        isOpen: false,
        tableData: []
      };
    },
    created() {
      this.setDataAsArray();
    },
    methods: {
      toggleChevron() {
        this.isOpen = !this.isOpen;
      },
      setDataAsArray() {
        this.tableData = Object.values(this.content);
      }
    }
  };
</script>

<style scoped>
  .action-plan-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1rem;
    padding-bottom: 24px;
  }
</style>
